// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gantt-section-panel{max-width:100vw;overflow-x:hidden}`, "",{"version":3,"sources":["webpack://./src/components/screens/Projects/ProjectPlanning.scss"],"names":[],"mappings":"AAAA,qBACE,eAAA,CACA,iBAAA","sourcesContent":[".gantt-section-panel {\n  max-width: 100vw;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
